import { render } from "./OffersFilters.vue?vue&type=template&id=28c7cbe8&scoped=true"
import script from "./OffersFilters.vue?vue&type=script&lang=js"
export * from "./OffersFilters.vue?vue&type=script&lang=js"

import "./OffersFilters.vue?vue&type=style&index=0&id=28c7cbe8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c7cbe8"]])

export default __exports__